'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React from 'react'

// lib
import Alert, { AlertProps } from '../../alert'

/* -----------------------------------------------------------------------------
 * FieldErrorMessage
 * -------------------------------------------------------------------------- */

type FieldErrorMessageProps = AlertProps & {}

const FieldErrorMessage = (props: FieldErrorMessageProps) => {
  return <Alert my='04' type='error' {...props} />
}

export default FieldErrorMessage
